import { Loading } from '@acin/ui-core';
import styled from 'styled-components';

export const ProcessMappings = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.getSize(3)};
  margin-top: ${(p) => p.theme.spacing.getSize(4)};
`;

export const InputSection = styled.div`
  padding: ${(p) => p.theme.spacing.getSize(3)} 0 0 0;
`;

export const Sentinel = styled.div`
  height: ${(p) => p.theme.spacing.getSize(5)};
  visibility: hidden;
`;

export const LoadingIndicator = styled(Loading)`
  display: block;
  margin: ${(p) => p.theme.spacing.getSize(3)} 0;
`;
